webpackJsonp([1],{

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = 'https://api.timspickermann.de';

/* harmony default export */ var components_calendar = ({
  name: 'calendar',
  data: function data() {
    return {
      backgroundImage: '',
      doors: [],
      imagePosition: {},
      openedDoor: 0,
      imagePreview: '',
      imagePreviewDescription: '',
      accessToken: ''
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var url, calendar, days, doors, _loop, i;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = BASE_URL + '/items/AdventCalenderUser/?access_token=' + _this.accessToken + '&fields=*,days.id,days.isOpened,days.AdventCalender_id.*,days.AdventCalender_id.image.*';
                _context.next = 3;
                return fetch(url).then(function (res) {
                  return res.json();
                });

              case 3:
                calendar = _context.sent.data[0];

                document.title = calendar.documentTitle;

                _this.backgroundImage = BASE_URL + '/assets/' + calendar.backgroundImage + '?access_token=' + _this.accessToken;

                days = calendar.dayOrder.split(',').map(function (n) {
                  return Number(n);
                });
                doors = [];

                _loop = function _loop(i) {
                  var door = {
                    day: days[i],
                    position: {
                      x: 16 * (i % 6) + 4,
                      y: 23.5 * Math.floor(i / 6) + 3.5,
                      w: 12,
                      h: 20,
                      day: days[i]
                    }
                  };
                  var data = calendar.days.find(function (el) {
                    return el.AdventCalender_id ? Number(el.AdventCalender_id.day) === days[i] : false;
                  });
                  if (data) {
                    door.id = data.id;
                    door.isOpened = data.isOpened;
                    door.image = BASE_URL + '/assets/' + data.AdventCalender_id.image.id + '?access_token=' + _this.accessToken;
                    door.description = data.AdventCalender_id.description || data.AdventCalender_id.image.description;
                  }
                  doors.push(door);
                };

                for (i = 0; i < 24; i++) {
                  _loop(i);
                }
                _this.doors = doors;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveDoorOpened: function saveDoorOpened(door) {
      fetch(BASE_URL + '/items/AdventCalenderUser_AdventCalender/' + door.id + '?access_token=' + this.accessToken, {
        method: 'PATCH',
        body: stringify_default()({ isOpened: true }),
        headers: {
          'content-type': 'application/json'
        }
      }).then(function (res) {
        return res.json();
      }).then(console.log);
    },
    toggleDoor: function toggleDoor(door, state) {
      if (!this.imagePreview && door.image) {
        if (state) this.openedDoor = door.day;else this.openedDoor = 0;
      }
    },
    showDoorContent: function showDoorContent(door) {
      if (door.image) {
        if (!door.isOpened) {
          door.isOpened = true;
          this.saveDoorOpened(door);
        }
        this.toggleDoor(door.day, true);
        this.imagePreview = door.image;
        this.imagePreviewDescription = door.description;
      }
    },
    getDoorStyle: function getDoorStyle(door) {
      return "top:" + door.position.y + "%;" + "left:" + door.position.x + "%;" + "width:" + door.position.w + "%;" + "height:" + door.position.h + "%;" + (door.image ? 'background-image:url(' + door.image + '&key=advent-calender-door);' : "");
    },
    getBackgroundImageStyle: function getBackgroundImageStyle(position) {
      var offsetLeft = this.imagePosition.left - position.x * window.innerWidth / 100;
      var offsetTop = this.imagePosition.top - position.y * window.innerHeight / 100;
      return "background-image:url(" + this.backgroundImage + ");" + "background-position:" + offsetLeft + "px " + offsetTop + "px;" + "background-size:" + this.imagePosition.width + "px " + this.imagePosition.height + "px;";
    },
    calcImagePosition: function calcImagePosition() {
      var img = document.getElementById("background-image");
      var imgWidth = img.naturalWidth;
      var imgHeight = img.naturalHeight;
      var width = document.documentElement.clientWidth; //window.innerWidth;
      var height = document.documentElement.clientHeight; //window.innerHeight;
      if (width / height > imgWidth / imgHeight) {
        // Full width
        this.imagePosition = { top: (height - imgHeight * width / imgWidth) / 2, left: 0, width: width, height: imgHeight * width / imgWidth };
      } else {
        // Full height
        this.imagePosition = { top: 0, left: (width - imgWidth * height / imgHeight) / 2, width: imgWidth * height / imgHeight, height: height };
      }
    }
  },
  created: function created() {
    if (location.pathname) {
      this.accessToken = location.pathname.slice(1);
      this.init();
    }
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.calcImagePosition);
    this.calcImagePosition();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edb39b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:({ backgroundImage: 'url(' + _vm.backgroundImage + ')' })},[_vm._l((_vm.doors),function(door){return _c('div',{key:door.day,staticClass:"door",style:(_vm.getDoorStyle(door)),on:{"click":function($event){return _vm.showDoorContent(door)},"mouseover":function($event){return _vm.toggleDoor(door, true)},"mouseout":function($event){return _vm.toggleDoor(door, false)}}},[_c('div',{staticClass:"door-fold",class:{ opened: _vm.openedDoor == door.day, locked: !door.image, sealed: !door.isOpened },style:(_vm.getBackgroundImageStyle(door.position))},[_c('span',[_vm._v(_vm._s(door.day))])])])}),_vm._v(" "),(_vm.imagePreview)?[_c('div',{staticClass:"dialog-container"},[(_vm.imagePreviewDescription)?_c('div',{staticClass:"dialog-description",on:{"click":function($event){_vm.imagePreviewDescription = ''}}},[_vm._v("\n        "+_vm._s(_vm.imagePreviewDescription)+"\n      ")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"dialog-image",attrs:{"src":_vm.imagePreview},on:{"click":function($event){_vm.imagePreview = ''}}})]),_vm._v(" "),_c('div',{staticClass:"dialog-shadow",on:{"click":function($event){_vm.imagePreview = ''}}})]:_vm._e(),_vm._v(" "),_c('img',{attrs:{"id":"background-image","src":_vm.backgroundImage},on:{"load":function($event){return _vm.calcImagePosition()}}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_calendar = (esExports);
// CONCATENATED MODULE: ./src/components/calendar.vue
function injectStyle (ssrContext) {
  __webpack_require__("SQcY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7edb39b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_calendar,
  selectortype_template_index_0_src_components_calendar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_calendar = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: {
    calendar: src_components_calendar
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025b6410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('calendar')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("nBU0")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "SQcY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nBU0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a63b182f0fd1e5847b4f.js